/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, IconButton, Badge } from '@material-ui/core';

const TooltipIconButton = (props) => {
  const {
    icon,
    title,

    tooltipProps,
    badgeContent,
    ...rest
  } = props;

  return (
    <Tooltip
      {...tooltipProps}
      title={title}
    >
      <div>
        <IconButton
          {...rest}
        >
          <Badge
            color="secondary"
            badgeContent={badgeContent}
          >
            {icon}
          </Badge>
        </IconButton>
      </div>
    </Tooltip>
  );
};

TooltipIconButton.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,

  tooltipProps: PropTypes.objectOf(PropTypes.any),
  badgeContent: PropTypes.number,
};

TooltipIconButton.defaultProps = {
  tooltipProps: {},
  badgeContent: 0,
};

export default TooltipIconButton;
